import { TextInput } from '@investoro/core';

export default TextInput;
